// Spanish translations
export const es = {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    loading: 'Cargando...',
    noResults: 'Sin resultados',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    back: 'Volver',
    next: 'Siguiente',
    close: 'Cerrar',
    export: 'Exportar',
    import: 'Importar'
  },
  auth: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    register: 'Registrarse',
    email: 'Correo',
    password: 'Contraseña',
    forgotPassword: '¿Olvidó su contraseña?',
    resetPassword: 'Recuperar contraseña',
    noAccount: '¿No tiene cuenta?',
    hasAccount: '¿Ya tiene cuenta?'
  },
  navigation: {
    dashboard: 'Panel',
    consents: 'Consentimientos',
    titulars: 'Titulares',
    groups: 'Grupos y Campañas',
    analytics: 'Analytics',
    expiringAlerts: 'Alertas Expiración',
    rtbf: 'Derecho al Olvido',
    qrCode: 'Código QR',
    otpValidation: 'Validación OTP',
    exportData: 'Exportar Datos',
    marketingActions: 'Acciones Marketing',
    importExport: 'Importar/Exportar',
    users: 'Usuarios',
    dataBreaches: 'Brechas de Datos',
    backups: 'Copias de Seguridad',
    auditLogs: 'Logs de Auditoría',
    settings: 'Configuración'
  },
  consents: {
    title: 'Gestión de Consentimientos',
    newConsent: 'Nuevo Consentimiento',
    activeConsents: 'Consentimientos Activos',
    revokedConsents: 'Consentimientos Revocados',
    pendingConsents: 'Consentimientos Pendientes',
    purposes: {
      newsletter: 'Newsletter',
      promotions: 'Promociones',
      events: 'Eventos',
      surveys: 'Encuestas',
      productUpdates: 'Actualizaciones de Producto'
    },
    status: {
      active: 'Activo',
      revoked: 'Revocado',
      pending: 'Pendiente',
      expired: 'Expirado'
    },
    evidence: 'Evidencia',
    expirationDate: 'Fecha de Expiración',
    retentionPeriod: 'Período de Retención'
  },
  titulars: {
    title: 'Gestión de Titulares',
    newTitular: 'Nuevo Titular',
    editTitular: 'Editar Titular',
    groups: 'Grupos',
    noGroups: 'Sin grupos'
  },
  groups: {
    title: 'Grupos de Titulares',
    newGroup: 'Nuevo Grupo',
    editGroup: 'Editar Grupo',
    members: 'Miembros',
    addMembers: 'Añadir Miembros'
  },
  campaigns: {
    title: 'Campañas de Marketing',
    newCampaign: 'Nueva Campaña',
    purpose: 'Finalidad',
    legalBasis: 'Base Legal',
    targetGroups: 'Grupos Objetivo',
    status: {
      draft: 'Borrador',
      pendingApproval: 'Pendiente Aprobación',
      approved: 'Aprobado',
      executed: 'Ejecutado',
      cancelled: 'Cancelado'
    },
    approve: 'Aprobar',
    execute: 'Ejecutar'
  },
  ropa: {
    title: 'Registro de Actividades de Tratamiento',
    exportPdf: 'Exportar PDF',
    exportExcel: 'Exportar Excel'
  },
  notifications: {
    title: 'Notificaciones',
    noNotifications: 'Sin notificaciones',
    markAllRead: 'Marcar todas',
    viewAll: 'Ver todas'
  },
  settings: {
    title: 'Configuración',
    language: 'Idioma',
    theme: 'Tema',
    lightTheme: 'Claro',
    darkTheme: 'Oscuro',
    autoTheme: 'Automático'
  }
};
